const appUrl =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1")
    ? `${window.location.protocol}//${window.location.host}/`
    : "https://app.hyperclapper.com/";

export const APP_BRANDING = {
  name: "Hyperclapper",
  logo: "/logo192.png",
  logo_dark: "/logo192.png",
  app_url: appUrl,
  title:
    "HyperClapper – LinkedIn Engagement Platform to Grow Views & Followers",
  description:
    "Boost your LinkedIn posts with HyperClapper. Increase views, likes, and engagement using AI-powered networks trusted by creators and professionals.",
  favicon: "/favicon.ico",
  connect_message:
    "Connect your LinkedIn profile to HyperClapper for an enhanced experience.",
  app_name: "HyperClapper",
};
